'use client'

import { useEffect, useState } from 'react'
import AuthFormClient from '@/components/AuthForm.client'
import type { AuthBlock } from '@/payload-types'
import { createClientLogger } from '@/lib/logger/client'

const log = createClientLogger('AuthBlock')

type AuthBlockClientProps = {
  className?: string
} & AuthBlock

export function AuthBlockClient({
  className,
  displayMode,
  defaultMode,
  intent,
  notLoggedInTitle,
  notLoggedInDescription,
  loggedInTitle,
  loggedInDescription,
  loggedInLinks,
}: AuthBlockClientProps) {
  const [flags, setFlags] = useState({ magicLinks: false, googleSignIn: false })
  const [googleClientId, setGoogleClientId] = useState('')
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function fetchAuthData() {
      try {
        // Fetch auth configuration from API
        const response = await fetch('/api/auth/config')
        if (response.ok) {
          const data = await response.json()
          setFlags(data.flags || { magicLinks: false, googleSignIn: false })
          setGoogleClientId(data.googleClientId || '')
          setIsAuthenticated(data.isAuthenticated || false)
        }
      } catch (error) {
        log.error({ error }, 'Failed to fetch auth config')
      } finally {
        setLoading(false)
      }
    }

    fetchAuthData()
  }, [])

  if (loading) return null
  // Build redirect path based on intent
  let redirectPath: string | undefined

  if (intent === 'create-accommodation') {
    redirectPath = '/mijn/accommodaties/nieuw'
  } else if (intent === 'create-foundation') {
    redirectPath = '/mijn/stichtingen-en-fondsen/nieuw'
  }

  return (
    <div className={className}>
      <AuthFormClient
        displayMode={displayMode || 'tabs'}
        defaultMode={defaultMode || 'register'}
        redirectPath={redirectPath}
        flags={flags}
        googleClientId={googleClientId}
        intent={intent || undefined}
        isAuthenticated={isAuthenticated}
        notLoggedInTitle={notLoggedInTitle}
        notLoggedInDescription={notLoggedInDescription}
        loggedInTitle={loggedInTitle}
        loggedInDescription={loggedInDescription}
        loggedInLinks={loggedInLinks}
      />
    </div>
  )
}
